import React from 'react'
import { Icon, Tag, Breadcrumb } from 'antd'
import * as _ from 'lodash'

import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'
import ListRender from './components/listRender'

import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}

class List extends ComponentExt<IProps, IState> {
  state = {
    list: [],
    listLen: 0,
    tags: [],
    recommendList: [],
    selectedTags: [],
    defaultKeys: '',
    defaultRequestParams: {},
    breadCrumb: [
      { linkTo: '/housework', text: '经传家事' },
      { linkTo: '', text: '专题详情' },
    ],
  }

  async componentDidMount() {
    const id = this.handleGetSearchParams('labelId')
    const defaultKeys = this.handleGetSearchParams('listType')
    const tagName = this.handleGetSearchParams('tagName')
    const breadCb = [
      { linkTo: '/housework', text: '经传家事' },
      { linkTo: '', text: tagName },
    ]
    const params = {
      label_type: 1,
      label_id: id,
      type: defaultKeys,
    }
    if (defaultKeys === '0') {
      delete params.type
    }
    this.setState(
      {
        breadCrumb: breadCb,
        selectedTags: [{ id }],
        defaultKeys,
        defaultRequestParams: params,
      },
      () => this.handleRequestList(params),
    )
  }

  // tslint:disable-next-line: variable-name
  handleRequestList = params => {
    this.handleFetchArticleList(params)
    this.handleFetchHotArticleList(params)
    this.handleFetchLabelList(params)
  }

  async handleFetchArticleList(params: {
    label_type?: number
    label_id?: number
    type?: number
    page?: number
    limit?: number
  }) {
    try {
      const {
        list,
        count: listLen,
      } = await this.api.family.getFamilyArticleList(params)
      this.setState({
        list,
        listLen,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleClickBreadCrumb = link => {
    if (link) {
      this.props.history.push('/housework')
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleGetSearchParams = type => {
    return new URLSearchParams(this.props.location.search).get(type)
  }

  handleRenderBreadCrumb = () => {
    const { breadCrumb } = this.state
    if (_.isEmpty(breadCrumb)) {
      return
    }
    return (
      <Breadcrumb separator=">">
        {_.map(breadCrumb, (itm, idx) => (
          <Breadcrumb.Item
            onClick={() => this.handleClickBreadCrumb(itm.linkTo)}
            key={idx}
          >
            <a>{itm.text}</a>
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    )
  }

  handleClickList = (e, data, type) => {
    const { selectedTags } = this.state

    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'li') {
      WINOPEN(`#/housework/detail/${type}?id=${data.id}`)
      // this.props.history.push(`housework/detail/${type}?id=${data.id}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/housework/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleClickMenu = e => {
    const { defaultRequestParams } = this.state
    const params: any = _.assign({}, defaultRequestParams)
    if (e.key === 'news') {
      delete params.type
    } else {
      params.type = Number(e.key)
      this.setState({ listType: Number(e.key) })
    }
    this.handleRequestList(params)
  }

  handleRenderList = () => {
    const { list } = this.state
    if (_.isEmpty(list)) {
      return
    }
    return _.map(list, (itm, idx) => (
      <li
        className={itm.type === '1000101' ? styles.vdBg : null}
        onClick={e => this.handleClickList(e, itm, 'li')}
        key={itm.id}
      >
        <div className={styles.listImg}>
          <img
            src={
              itm.img_url ||
              'http://xy-v.jingzhuan.cn/image/dbcc47bdb414b2bb78ac3727ab565e16.png'
            }
            alt=""
          />
        </div>
        <div className={styles.listContent}>
          <h4>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </h4>
          <p style={{ minHeight: '44px' }}>
            {this.handleSliceString(itm.article_desc, 50)}
          </p>
          <span>{itm.publish_date.split(' ')[0]}</span>
          {itm.label.length > 0 &&
            _.map(itm.label, item => (
              <span
                onClick={e => this.handleClickList(e, item, 'tag')}
                key={item.id}
                className={styles.listTag}
              >{`#${item.label_name}`}</span>
            ))}
        </div>
      </li>
    ))
  }

  handleRenderTag = () => {
    const { tags, selectedTags } = this.state
    if (_.isEmpty(tags)) {
      return
    }

    return _.map(tags, itm => (
      <Tag
        key={itm.id}
        color={
          _.findIndex(selectedTags, o => o.id * 1 === itm.id) > -1 && '#108ee9'
        }
        onClick={e => this.handleClickList(e, itm, 'tag')}
      >
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </li>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  render() {
    const that = this
    const { listLen, breadCrumb, defaultKeys } = this.state
    const {
      handleRenderBreadCrumb,
      handleRenderList,
      handleRenderTag,
      handleClickMenu,
      handleRenderRecommend,
    } = this
    const mapListRenderProps: any = {
      that,
      listLen,
      defaultKeys,
      handleClickMenu,
      handleRenderList,
      handleRenderTag,
      handleRenderRecommend,
    }
    return (
      <div className={styles.list}>
        <>{handleRenderBreadCrumb()}</>
        <div className={styles.content}>
          <div className={styles.tag}>
            <Icon type="tag" />
            {breadCrumb[1].text}
          </div>
          <ListRender {...mapListRenderProps} />
        </div>
      </div>
    )
  }
}

export default List
